import { render, staticRenderFns } from "./ExtraSubscriptionCredit.vue?vue&type=template&id=2a5799ec&scoped=true&"
import script from "./ExtraSubscriptionCredit.vue?vue&type=script&lang=js&"
export * from "./ExtraSubscriptionCredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5799ec",
  null
  
)

export default component.exports